import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Party } from '../models/party';
import { PartyType } from '../models/party-type';
import { CustomValidators } from 'ng2-validation';
import { TranslateService } from '@ngx-translate/core';
import { OnyxEvent } from '../models/event';
import { Contact } from '../models/contact';

@Component({
  selector: 'pioneer-contact-form',
  templateUrl: './contact-form.component.html'
})
export class ContactFormComponent implements OnInit, OnChanges {
  @Input('partyType')
  public partyType: PartyType;

  @Input('parentForm')
  public parentForm: FormGroup;

  public onyxEvent: OnyxEvent;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input()
  public isReadOnly = true;

  @Input()
  public clientContactEditable;

  public contactForm: FormGroup;

  public contactTypeTitle: string;
  public contactReferenceNumberTitle: string;

  constructor(private formBuilder: FormBuilder,
              private translateService: TranslateService) {
  }

  private dataToFormGroup(event: OnyxEvent): void {
    let party = new Party();

    switch (this.partyType) {
      case PartyType.CLIENT:
        party = this.onyxEvent.eventClient;
        break;
      case PartyType.AGENCY:
        party = this.onyxEvent.eventAgency;
        break;
      case PartyType.PROPERTY:
        party = this.onyxEvent.eventProperty;
        break;
      default:
        throw Error(`Invalid partyType ${this.partyType}`);
    }

    if (!party) {
      party = new Party({ contact: new Contact() });
    } else if (!party.contact) {
      party.contact = new Contact();
    }

    let refCodeValidator = [ party.eventReferenceNumber, Validators.nullValidator ];
    if (this.partyType === PartyType.PROPERTY) {
      refCodeValidator = [ party.eventReferenceNumber, Validators.nullValidator ];
    }

    if (!this.contactForm) {
      this.contactForm = this.formBuilder.group({
        name: party.name,
        line1: party.line1,
        line2: party.line2,
        partyType: this.partyType,
        city: party.city,
        state: party.state,
        postalCode: party.postalCode,
        agencyId: party.code,
        code: party.code,
        propertyId: party.propertyId,
        chain: party.chain,
        brand: party.brand,
        eventReferenceNumber: refCodeValidator,
        contact: this.formBuilder.group({
          firstName: party.contact.firstName,
          lastName: party.contact.lastName,
          partyType: this.partyType,
          email: [ party.contact.email, CustomValidators.email ],
          phone: [ party.contact.phone, CustomValidators.phone ],
          fax: [ party.contact.fax, CustomValidators.phone ]
        })
      });
    } else {
      this.contactForm.patchValue({
        name: party.name,
        line1: party.line1,
        line2: party.line2,
        partyType: this.partyType,
        city: party.city,
        state: party.state,
        postalCode: party.postalCode,
        agencyId: party.code,
        code: party.code,
        propertyId: party.propertyId,
        chain: party.chain,
        brand: party.brand,
        eventReferenceNumber: party.eventReferenceNumber,
      });
      this.contactForm.controls[ 'contact' ].patchValue({
        firstName: party.contact.firstName,
        lastName: party.contact.lastName,
        partyType: this.partyType,
        email: party.contact.email,
        phone: party.contact.phone,
        fax: party.contact.fax
      });
    }
  }

  ngOnInit() {
    switch (this.partyType) {
      case PartyType.CLIENT:
        this.translateService.get('EVENT.CONTACT_CLIENT').subscribe(text => this.contactTypeTitle = text);
        this.translateService.get('EVENT.CONTACT_CLIENT_REF_CODE')
          .subscribe(text => this.contactReferenceNumberTitle = text);
        this.dataToFormGroup(this.onyxEvent);
        this.parentForm.setControl('eventClient', this.contactForm);
        break;
      case PartyType.AGENCY:
        this.translateService.get('EVENT.CONTACT_AGENCY').subscribe(text => this.contactTypeTitle = text);
        this.translateService.get('EVENT.CONTACT_AGENCY_REF_CODE')
          .subscribe(text => this.contactReferenceNumberTitle = text);
        this.dataToFormGroup(this.onyxEvent);
        this.parentForm.setControl('eventAgency', this.contactForm);
        break;
      case PartyType.PROPERTY:
        this.translateService.get('EVENT.CONTACT_PROPERTY').subscribe(text => this.contactTypeTitle = text);
        this.translateService.get('EVENT.CONTACT_PROPERTY_REF_CODE')
          .subscribe(text => this.contactReferenceNumberTitle = text);
        this.dataToFormGroup(this.onyxEvent);
        this.parentForm.setControl('eventProperty', this.contactForm);
        break;
      default:
        throw Error(`Invalid partyType ${this.partyType}`);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes[ 'event' ]) {
      return;
    }

    this.dataToFormGroup(this.onyxEvent);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/contact-form/contact-form.component.ts